import { render, staticRenderFns } from "./barF5.vue?vue&type=template&id=0622506d&scoped=true&"
import script from "./barF5.vue?vue&type=script&lang=js&"
export * from "./barF5.vue?vue&type=script&lang=js&"
import style0 from "./barF5.vue?vue&type=style&index=0&id=0622506d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622506d",
  null
  
)

export default component.exports